import React from 'react';

export default class Page2 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt people">
                                    <div className="innerpadding">


                                        <div className="ilead-contentarea">
                                            <div className="border_subtitle">This tool can help</div>
                                            <p>Knowledge of our personal learning styles is important to ensure
                                                we tap into the learning styles
                                                that we can use most effectively. This tool is about <span
                                                    className="brown brownbold">how to identify personal learning styles</span>
                                                and will help you to understand the characteristics underlying
                                                different learning styles and how
                                                to identify your own learning style. Different learning styles
                                                will be explored to help you consider
                                                how others learn.</p>


                                            <div className="circle_title">
<span className="heading">
<img className="heading_image" src={require('@images/browndot.jpg')}/>
</span>
                                                <span className="heading">LEARNING STYLES ARE IMPORTANT</span>
                                            </div>

                                            <div className="border_subtitle">Why is it important to consider
                                                your learning style?
                                            </div>
                                            <p>How easily do you learn new techniques or processes, assimilate
                                                information and generally adapt
                                                in a continually evolving business environment? Have you noticed
                                                that some members of your
                                                team are more motivated or better adapted to learn than others?
                                                If you’re planning a developmental
                                                activity for yourself or them, understanding that we all have
                                                preferred (and therefore more
                                                effective) methods of learning could save time and money, or
                                                make the difference between
                                                partial and complete success.</p>

                                            <div className="border_subtitle">Kolb’s experiential learning theory
                                                model<a className="superscripttext supLinesapce boldlink"
                                                        href="further_info.php?course=300"><sup>2</sup></a>
                                            </div>
                                            <p>This well known theory suggests that the way an individual learns
                                                is linked to his or her
                                                preferences or choices, and that it is a continual, cyclical
                                                process of experience, reflection,
                                                thought and finally action. Action involves experimentation or
                                                testing, which leads to a new,
                                                different experience, and so the cycle begins again.
                                            </p>
                                            <p>During the observations and comparisons which led him to this
                                                theory, Kolb identified four
                                                different ways of learning – or ‘personal learning styles’:</p>

                                            <div className="border_subtitle">Diverging</div>
                                            <div className="uiheading "><p><span className="subtiltereg">A mixture of concrete experience and reflective observation.</span>
                                            </p></div>
                                            <p>This is a preference for watching rather than doing. People who
                                                learn this way tend to have an
                                                ‘open minded’ attitude and work best in groups, or situations
                                                where different perspectives are
                                                available to compare or amalgamate with their own
                                                interpretation, to reach an understanding
                                                or solution.</p>

                                            <div className="border_subtitle">Assimilating</div>
                                            <div className="uiheading "><p><span className="subtiltereg">A mixture of abstract conceptualisation and reflective observation.</span>
                                            </p></div>
                                            <p>A preference for a concise, logical approach with good clear
                                                explanation. People who learn in an
                                                ‘assimilative’ way are able to comprehend a wide-ranging variety
                                                of information and organise it
                                                clearly and logically. They may appreciate the logic and theory
                                                of a proposal, rather than its
                                                practical application.</p>

                                            <div className="border_subtitle">Converging</div>
                                            <div className="uiheading "><p><span className="subtiltereg">A mixture of abstract conceptualisation and active experimentation. </span>
                                            </p></div>
                                            <p>People with a converging style of learning like to experiment
                                                with new ideas which they can then
                                                use practically – they tend to prefer technical tasks.</p>

                                            <div className="border_subtitle">Accommodating</div>
                                            <div className="uiheading "><p><span className="subtiltereg">A mixture of concrete experience and active experimentation.</span>
                                            </p></div>
                                            <p>An approach which uses given data, or other people’s analysis, to
                                                work out a practical solution.
                                                Such people like challenges and new experiences, often acting on
                                                ‘gut instinct’ rather than logical
                                                analysis. They may prefer to work with others to complete
                                                tasks.</p>


                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page1')}
                                                    className="button-next-previous-done">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page3')}
                                                    className="button-next-previous-done">Next &gt;&gt;</div>
                                            </div>


                                        </div>

                                    </div>


                                </div>


                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}